import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FileIcon from "../../../Icons/FileIcon";

function createData(id, item, file, expirationDate, status) {
  return { id, item, file, expirationDate, status };
}

const rows = [
  createData("1", "Employment Info", "Employment Info.pdf", "-", "Completed"),
  createData("2", "Employment Info", "Employment Info.pdf", "-", "Completed"),
  createData("3", "Employment Info", "Employment Info.pdf", "-", "Completed"),
];

function ApplicantOfferOnOfferTable() {
  return (
    <div>
      <TableContainer component={Paper} className="tableContainer">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: "#FAFAFB" }}>
            <TableRow>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                #
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                Item
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                File
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                Expiration Date
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left" className="customTableBody">
                  {row.id}
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  {row.item}
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  <div className="flex gap-2 justify-between items-center">
                    <div className="flex gap-[0.5rem] items-center">
                      <FileIcon />
                      <span>{row.file}</span>
                    </div>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM12.28 15.78L10.28 17.78C10.21 17.85 10.12 17.91 10.03 17.94C9.94 17.98 9.85 18 9.75 18C9.65 18 9.56 17.98 9.47 17.94C9.39 17.91 9.31 17.85 9.25 17.79C9.24 17.78 9.23 17.78 9.23 17.77L7.23 15.77C6.94 15.48 6.94 15 7.23 14.71C7.52 14.42 8 14.42 8.29 14.71L9 15.44V11.25C9 10.84 9.34 10.5 9.75 10.5C10.16 10.5 10.5 10.84 10.5 11.25V15.44L11.22 14.72C11.51 14.43 11.99 14.43 12.28 14.72C12.57 15.01 12.57 15.49 12.28 15.78Z"
                        fill="#1E87FF"
                      />
                      <path
                        d="M17.4297 8.81048C18.3797 8.82048 19.6997 8.82048 20.8297 8.82048C21.3997 8.82048 21.6997 8.15048 21.2997 7.75048C19.8597 6.30048 17.2797 3.69048 15.7997 2.21048C15.3897 1.80048 14.6797 2.08048 14.6797 2.65048V6.14048C14.6797 7.60048 15.9197 8.81048 17.4297 8.81048Z"
                        fill="#1E87FF"
                      />
                    </svg>
                  </div>
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  {row.expirationDate}
                </TableCell>
                <TableCell
                  align="left"
                  className="!text-[#32D583] font-bold customTableBody"
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.75rem",
                  }}
                >
                  {row.status}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default ApplicantOfferOnOfferTable;
